import { boot } from "quasar/wrappers";
//import { AnalyticsBrowser } from "@june-so/analytics-next";

export default boot(() => {
  // if (!process.env.JUNE_WRITE_KEY) {
  //   console.error("No JUNE_WRITE_KEY found in .env");
  //   return;
  // }
  // window.juneAnalytics = AnalyticsBrowser.load({
  //   writeKey: process.env.JUNE_WRITE_KEY,
  // });
  // router.afterEach(async (to, from, failure) => {
  //   if (!failure) {
  //     await window.juneAnalytics?.page(to.fullPath);
  //   }
  // });
});
